import React from 'react';

type FormInputProps<D> = {
  label: string;
  name: fieldNames<D>;
  inline?: boolean;
  data: D & { [key: string]: string };
  changeFn: (d: fieldNames<D>, a: React.FormEvent<HTMLInputElement>) => void;
  blurFn?: (e: React.FocusEvent) => void;
  validation: fieldNames<D>[];
}

// This should be "keyof F" but we get odd string|number simplifications
type fieldNames<F> = React.ReactText;

export function FormInput<D>({ label, name, data, inline, changeFn, blurFn, validation }: FormInputProps<D>) {

  if (inline) {
    return <input type="text"
      className={"uk-input uk-form-small" + (validation.includes(name) ? " uk-form-danger" : "")}
      width="6"
      value={data[name]}
      placeholder={label}
      onBlur={blurFn ? (e) => blurFn(e) : undefined}
      onChange={(e) => changeFn(name, e)} />

  }
  return <p>
    <label className={validation.includes(name) ? 'uk-text-danger' : ''}>{label}:</label>
    <input type="text"
      className={"uk-input" + (validation.includes(name) ? " uk-form-danger" : "")}
      width="10"
      value={data[name]}
      onChange={(e) => changeFn(name, e)}
      onBlur={blurFn ? (e) => blurFn(e) : undefined}
    />
  </p>
}
